import axios from 'axios';
import {FLIGHT_API_URL, BASE_URL, API_URL} from '../constants/index.js';
import {handleResponse, handleError, useInterceptor} from './apiUtils';

useInterceptor(axios);

export function getPartners(params) {
	return axios({ method: 'get', url: `${API_URL}/vendors`, params });
}
export function getAllPartners(params) {
	return axios({ method: 'get', url: `${API_URL}/admin/vendors`, params });
}
/** Admin: get single vendor (includes listing_pending). */
export function getAdminVendor(idOrIdx) {
	return axios({ method: 'get', url: `${API_URL}/admin/vendors/${idOrIdx}` });
}
export function showPartner(id) {
	return axios({ method: 'get', url: `${API_URL}/vendors/${id}` });
}
export function createPartner(data) {
	return axios({ method: 'post', url: `${API_URL}/vendors`, data: { vendor: data } });
}
export function createAdminPartner(data) {
	return axios({ method: 'post', url: `${API_URL}/admin/vendors`, data: { vendor: data } });
}
export function updateAdminPartner(idOrIdx, data) {
	return axios({ method: 'patch', url: `${API_URL}/admin/vendors/${idOrIdx}`, data: { vendor: data } });
}
export function updatePartner(id, data) {
	return axios({ method: 'put', url: `${API_URL}/vendors/${id}`, data: { vendor: data } });
}
export function deletePartner(id) {
	return axios({ method: 'delete', url: `${API_URL}/vendors/${id}` });
}
/** Admin delete: uses admin endpoint so backend reverts linked user to General role. */
export function deleteAdminPartner(idOrIdx) {
	return axios({ method: 'delete', url: `${API_URL}/admin/vendors/${idOrIdx}` });
}
export function confirmPartner(id) {
	return axios({ method: 'put', url: `${API_URL}/vendors/${id}/confirm` });
}
export function partner_details(id) {
	return axios({ method: 'get', url: `${API_URL}/users/vendor_details/${id}` });
}
export function activatePartner(id) {
	return axios({ method: 'put', url: `${API_URL}/admin/vendors/${id}/activate` });
}
export function deactivatePartner(id) {
	return axios({ method: 'put', url: `${API_URL}/admin/vendors/${id}/deactivate` });
}
export function restoreAdminPartner(idOrIdx) {
	return axios({ method: 'put', url: `${API_URL}/admin/vendors/${idOrIdx}/restore` });
}
export function getRentalPartners(params) {
	return axios({ method: 'get', url: `${API_URL}/rental_vendors`, params });
}
export function updatePartnerDetails(id, details) {
	return axios({ method: 'patch', url: `${API_URL}/vendors/${id}/update_vendor_detail`, data: { vendor: details } });
}

/** Vendor: counts of assignments where vendor_completed_at IS NULL (pending vendor action). */
export function getPartnerPendingCounts() {
	return axios({ method: 'get', url: `${API_URL}/partners/pending_counts` });
}